
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speakers/[[...slug]]",
      function () {
        return require("private-next-pages/speakers/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speakers/[[...slug]]"])
      });
    }
  